import { faImage } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { DropZone, FileDropItem, FileTrigger, Text } from 'react-aria-components'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/Button'

type Props = {
  isDisabled?: boolean
  updatePhoto: (file: File) => void
}

export default function RecipePhotoForm({ updatePhoto, isDisabled }: Props) {
  const { t } = useTranslation()

  return (
    <div className="RecipePhotoUpload">
      <DropZone
        isDisabled={isDisabled}
        getDropOperation={(types) => {
          if (types.has('image/jpeg') || types.has('image/png')) {
            return 'copy'
          }
          return 'cancel'
        }}
        onDrop={async (e) => {
          const files = e.items.filter((file) => file.kind === 'file') as FileDropItem[]
          const fileData = await files[0].getFile()

          updatePhoto(fileData)
        }}>
        <FileTrigger
          acceptedFileTypes={['image/jpeg', 'image/png', 'image/jpg', 'image/webp']}
          onSelect={(e: FileList) => {
            updatePhoto(e[0])
          }}>
          <Button className="RecipePhotoUpload-trigger" isDisabled={isDisabled}>
            <FontAwesomeIcon icon={faImage} size="4x" color="var(--gray-100)" />
            <Text className="RecipePhotoUpload-label">{t('recipe.uploadHelp')}</Text>
          </Button>
        </FileTrigger>
      </DropZone>
    </div>
  )
}
